import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function queryErrorMessage(
  error: unknown,
  isError: boolean,
  fallback = "Failed",
): string | null {
  if (error instanceof Error) return error.message;
  if (isError) return fallback;
  return null;
}

/** Redirect to login when a query fails with Not signed in. */
export function useAuthRedirectOnQueryError(errorMsg: string | null) {
  const navigate = useNavigate();
  useEffect(() => {
    if (errorMsg === "Not signed in") {
      navigate("/login", { replace: true });
    }
  }, [errorMsg, navigate]);
}
